export default "__VITE_ASSET__BXKsNbqT__"